<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    仙湖路站<br>
站点介绍<br>
仙湖路站位于深圳罗湖莲塘片区的国威路与仙湖路交汇处，车站沿国威路道路东西方向布置，东接莲塘站，西接莲塘口岸站。 仙湖路站采用标准化的材料体现建筑本体，用现代、简约的手法体现地域文化、区域文化，综合轨道交通现有的设置进行系统设计，使形式、功能造型达到最优。仙湖路站为地下二层车站，地下一层为站厅层，地下二层为站台层。车站设置有6个出入口，车站周边为成熟配套生活区，以居住用地和教育用地为主，分布了坳下村、鹏兴花园、鹏兴工业区、鹏兴实验学校、罗湖外语学校、鹏兴第一幼儿园等，车站北侧离景点仙湖植物园较近。<br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:03	23:30	2号线	2分35秒	5分45秒<br>
莲塘	06:32	00:10	2号线	2分35秒	5分45秒<br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	23:29	2号线	4分钟	5分钟<br>
莲塘	06:32	00:10	2号线	4分钟	5分钟<br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:04	00:19	2号线	4分钟	5分钟<br>
莲塘	06:32	01:10	2号线	4分钟	5分钟<br>
<br>
站点出口信息<br>
A1、A2出入口:<br>
仙湖路东侧（南）、深圳市鹏兴实验学校<br>
B1、B2出入口:<br>
国威路北侧（东）、莲塘街道办、坳下村<br>
C1出入口:<br>
国威路北侧（西）、深圳市鹏兴第一幼儿园、罗湖外语学校<br>
C2、C3出入口:<br>
仙湖路西侧（北）、仙湖植物园<br>
公交换乘信息<br>
<br>
公交站名： A1、A2出入口丨鹏基工业区<br>
27、M468<br>
<br>
公交站名： 鹏基工业区①<br>
27
<br>
公交站名： 鹏基工业区②<br>
M468<br>
<br>
公交站名： 鹏兴实验学校南<br>
M468<br>
<br>
公交站名： 鹏兴花园六期<br>
M468<br>
<br>
公交站名： B1、B2出入口丨莲塘街道办<br>
27、113、B621<br>
<br>
公交站名： 莲塘街道办<br>
27、113、B621、M468<br>
<br>
公交站名： 鹏兴实验学校<br>
27、B621<br>
<br>
公交站名： 鹏兴实验学校<br>
27、B621<br>
<br>
公交站名： C1出入口丨罗湖外国语学校<br>
B621、57、113、202<br>
<br>
公交站名： 罗湖外国语学校<br>
B621、57、113<br>
<br>
公交站名： C2、C3出入口丨仙湖路地铁站<br>
220<br>
<br>
公交站名： 仙湖路地铁站<br>
220<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>